import "./index.css";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/layout/app-shell";
import { ErrorBoundary } from "@/components/layout/error-boundary";
import { RequireAuth } from "@/components/layout/require-auth";
import { Dashboard } from "@/routes/dashboard";
import { Landing } from "@/routes/landing";
import { NotFound } from "@/routes/not-found";
import { RepoPicker } from "@/routes/repo-picker";
import { queryClient } from "@/lib/query-client";
import { persistOptions } from "@/lib/persist/query-persister";

export function App() {
  return (
    <ErrorBoundary>
      <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
        <BrowserRouter>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<Landing />} />
              <Route path="*" element={<NotFound />} />
              <Route element={<RequireAuth />}>
                <Route path="/pick" element={<RepoPicker />} />
                <Route path="/repo/:owner/:name" element={<Dashboard />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </PersistQueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
